
export const settings = {
    BANNER_ID:"banner_setting"
};
